export const TREE_OF_LIFE_10_LAYOUT = {
    id: 'tree-of-life-10',
    family: 'tree',
    cards: 10,
    description: 'Albero della Vita coerente con la geometria sephirotica e i suoi assi simbolici.',
    supports_focus_overlay: true,
    variants: [
        {
            id: 'portrait',
            points: [
                { x: 50, y: 8, z: 1 },
                { x: 30, y: 22, z: 1 },
                { x: 70, y: 22, z: 1 },
                { x: 30, y: 40, z: 1 },
                { x: 70, y: 40, z: 1 },
                { x: 50, y: 52, z: 2 },
                { x: 30, y: 68, z: 1 },
                { x: 70, y: 68, z: 1 },
                { x: 50, y: 82, z: 1 },
                { x: 50, y: 94, z: 1 },
            ],
        },
        {
            id: 'compact',
            points: [
                { x: 50, y: 12, z: 1 },
                { x: 32, y: 24, z: 1 },
                { x: 68, y: 24, z: 1 },
                { x: 32, y: 42, z: 1 },
                { x: 68, y: 42, z: 1 },
                { x: 50, y: 54, z: 2 },
                { x: 32, y: 70, z: 1 },
                { x: 68, y: 70, z: 1 },
                { x: 50, y: 84, z: 1 },
                { x: 50, y: 94, z: 1 },
            ],
        },
    ],
};
//# sourceMappingURL=tree-of-life-10.js.map